import { Action, State, StateContext } from '@ngxs/store';

import { PaymentInfo } from './payment-info.model';
import * as PaymentInfoActions from './payment-info.actions';

@State<PaymentInfo>({
  name: 'paymentInfo',
  defaults: new PaymentInfo()
})
export class PaymentInfoState {
  @Action(PaymentInfoActions.SetToken)
  setToken(
    { getState, setState }: StateContext<PaymentInfo>,
    { payload }: PaymentInfoActions.SetToken
  ) {
    setState({ ...getState(), token: payload});
  }
  @Action(PaymentInfoActions.ClearToken)
  clearToken(
    { getState, setState }: StateContext<PaymentInfo>,
  ) {
    setState({ ...getState(), token: '', tokenValidationError: ''});
  }
  @Action(PaymentInfoActions.SetTokenValidation)
  setTokenValidation(
    { getState, setState }: StateContext<PaymentInfo>,
    { payload }: PaymentInfoActions.SetTokenValidation
  ) {
    setState({ ...getState(), tokenValidationError: payload});
  }
  @Action(PaymentInfoActions.SetNumber)
  setNumber(
    { getState, setState }: StateContext<PaymentInfo>,
    { payload }: PaymentInfoActions.SetNumber
  ) {
    setState({ ...getState(), number: payload });
  }
  @Action(PaymentInfoActions.SetMonth)
  setMonth(
    { getState, setState }: StateContext<PaymentInfo>,
    { payload }: PaymentInfoActions.SetMonth
  ) {
    setState({ ...getState(), month: payload.toString() });
  }
  @Action(PaymentInfoActions.SetYear)
  setYear(
    { getState, setState }: StateContext<PaymentInfo>,
    { payload }: PaymentInfoActions.SetYear
  ) {
    setState({ ...getState(), year: payload.toString() });
  }
  @Action(PaymentInfoActions.SetCVV)
  setCVV(
    { getState, setState }: StateContext<PaymentInfo>,
    { payload }: PaymentInfoActions.SetCVV
  ) {
    setState({ ...getState(), cvv: payload.toString() });
  }
  @Action(PaymentInfoActions.SetAccount)
  setAccount(
    { getState, setState }: StateContext<PaymentInfo>,
    { payload }: PaymentInfoActions.SetAccount
  ) {
    setState({ ...getState(), account: payload });
  }
  @Action(PaymentInfoActions.SetRouting)
  setRouting(
    { getState, setState }: StateContext<PaymentInfo>,
    { payload }: PaymentInfoActions.SetRouting
  ) {
    setState({ ...getState(), routing: payload });
  }
  @Action(PaymentInfoActions.SetMethod)
  setMethod(
    { getState, setState }: StateContext<PaymentInfo>,
    { payload }: PaymentInfoActions.SetMethod
  ) {
    setState({ ...getState(), method: payload });
  }
  @Action(PaymentInfoActions.SetCardRetain)
  setCardRetain(
    { getState, setState }: StateContext<PaymentInfo>,
    { payload }: PaymentInfoActions.SetCardRetain
  ) {
    setState({ ...getState(), retain: payload });
  }
  @Action(PaymentInfoActions.SetMethodAdd)
  setMethodAdd(
    { getState, setState }: StateContext<PaymentInfo>,
    { payload }: PaymentInfoActions.SetMethodAdd
  ) {
    setState({ ...getState(), add: payload });
  }
  @Action(PaymentInfoActions.SetCardType)
  setCardType(
    { getState, setState }: StateContext<PaymentInfo>,
    { payload }: PaymentInfoActions.SetCardType
  ) {
    setState({ ...getState(), cardType: payload });
  }
}
